// ABOUTME: Login transition overlay component with magical fade effect
// ABOUTME: Provides 3-second graceful transition from auth page to dashboard
import React, { useEffect, useState } from 'react';
import './LoginTransition.css';

const LoginTransition = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out after 2.5 seconds (leaving 0.5s for CSS transition)
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 2500);

    // Complete transition after 3 seconds total
    const completeTimer = setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, 3000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className={`login-transition-overlay ${fadeOut ? 'fade-out' : ''}`}>
      <div className="transition-content">
        <div className="magical-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <h2 className="transition-message">Preparando seu Oráculo...</h2>
        <p className="transition-submessage">Os 12 Raios estão se alinhando</p>
      </div>
    </div>
  );
};

export default LoginTransition;
